import "../chunk-D57E6H3M.mjs";

// src/hooks/useShadowPortalContainer.ts
import { useCallback, useState } from "react";
var PORTAL_HOST_ATTRIBUTE = "data-buyscout-portal-host";
function shadowPortalContainer(node) {
  const element = node instanceof Element ? node : node?.parentElement;
  const host = element?.closest(`[${PORTAL_HOST_ATTRIBUTE}]`);
  if (host) return host;
  const root = node?.getRootNode();
  if (!(root instanceof ShadowRoot)) return void 0;
  return root.getElementById("buyscout-shadow-root") ?? root;
}
function useShadowPortalContainer(forwardedRef) {
  const [container, setContainer] = useState(void 0);
  const ref = useCallback((node) => {
    if (forwardedRef) forwardedRef.current = node;
    if (!node) return;
    const shadowContainer = shadowPortalContainer(node);
    if (shadowContainer) setContainer(shadowContainer);
  }, [forwardedRef]);
  return [container, ref];
}
export {
  PORTAL_HOST_ATTRIBUTE,
  shadowPortalContainer,
  useShadowPortalContainer
};
//# sourceMappingURL=useShadowPortalContainer.mjs.map